import { CompositeCommand, type ICommand } from '../../../core/commands/ICommand';
import { createEmptyDelta, type ScenarioDelta } from '../../../core/data-profiles/scenarios/ScenarioDelta';
import { isScenarioRecordable } from '../commands/IScenarioRecordable';

/** Capture one authored gesture before execution. Never execute its Yjs inverse. */
export function atlasCommandContribution(command: ICommand): ScenarioDelta | null {
  const delta = createEmptyDelta();
  const collect = (part: ICommand): boolean => {
    if (part instanceof CompositeCommand) return part.getCommands().every(collect);
    if (!isScenarioRecordable(part)) return false;
    const contribution = part.toScenarioDelta();
    // Keep contributions ordered; semantic translation coalesces same-field
    // patches. Mixed unsupported commands fail before ANY child executes.
    for (const key of ['additions', 'removals', 'moves', 'updates', 'edgeAdditions', 'edgeRemovals'] as const) {
      const values = contribution[key];
      if (values) (delta[key] as unknown[]).push(...values);
    }
    return true;
  };
  return collect(command) ? structuredClone(delta) : null;
}
